export const geocodeAddress = async (address: string) => {
  const normalizedAddress = address.trim();
  if (!normalizedAddress) throw new Error('address-not-found');

  const query = encodeURIComponent(normalizedAddress);
  let response: Response;

  try {
    response = await fetch(`https://photon.komoot.io/api/?q=${query}&limit=1`);
  } catch {
    throw new Error('address-geocoding-failed');
  }

  if (!response.ok) throw new Error('address-geocoding-failed');

  const data = await response.json();
  const coordinates = data.features?.[0]?.geometry?.coordinates;

  if (!coordinates || !coordinates.every(Number.isFinite)) {
    throw new Error('address-not-found');
  }

  return { lng: coordinates[0], lat: coordinates[1] };
};
